<template>
    <div class="text-center">
        <v-dialog v-model="show" transition="dialog-top-transition" activator="parent">
            <v-card width="400">
                <v-card-title>
                    <div class="text-h6" style="font-family: Montserrat, sans-serif !important;">{{ title }}</div>
                </v-card-title>

                <v-card-text>
                   
                    <v-text-field color="#9c27b0" label="name" density="comfortable" v-model="name"
                        variant="outlined">
                    </v-text-field>
                      <v-autocomplete variant="outlined" density="comfortable" v-model="val.extrasTypeId" clearable
                        :items="distribution" item-title="name" item-value="id" label="Distribution Cycle">
                    </v-autocomplete>
                    <v-autocomplete hide-details variant="outlined" density="comfortable" v-model="val.membersRoleId" clearable
                        :items="memberRole" item-title="type" item-value="id" label="Member Type">
                    </v-autocomplete>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="white" style="background: rgb(4 43 76);" @click="(show = false)">
                        cancel
                    </v-btn>
                    <v-btn color="white" style="background: rgb(4 43 76);" @click="edit()">
                        save
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'editExtra',
    data() {
        return {
            dialog: false,
            // name: '',
            // name: '',
            distribution:'',
             distribution:[
                {
                    id:1,
                    name: 'Weekly'
                },
                {
                    id:2,
                    name: 'Monthly'
                },
                {
                    id:3,
                    name: 'Every two weeks'
                },
            ]
        }
    },
    props: {
        visible: {
            type: Boolean,
        },
        title: {
            type: String
        },
        name: {
            type: String
        },
        val: {
            type: Array
        }

    },
    computed: {
        ...mapState('member', ['memberRole']),
        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },
    methods: {
        edit() {

            const payload = {
                id: this.val.id,
                extrasname: this.name,
                extrasTypeId: this.val.extrasTypeId,
                membersRoleId: this.val.membersRoleId,
            }
            // console.log(payload)
            this.$emit('save', payload);
            

        }
    },
    created() {
       

    }
}
</script>
<style scoped>
.v-input__prepend {
    display: none !important;
}

input:focus {
    outline: none !important;
}
</style>